import React, { Fragment } from 'react'
import { useDataTable } from '../../../shared/hooks/DataTable';
import { PaymentLogService } from '../PaymentLogService';
import { Tag } from 'primereact/tag';
import moment from 'moment';
const ThanhToanQr = () => {
  const header = 'Thanh toán QRCode';
  const dataKey = 'id';
  const { render: renderDataTable, } = useDataTable({
    header,
    dataKey,
    columns: [
      {
        field: 'securityNo',
        header: 'Mã tra cứu',
        width: 150,
        matchMode: 'contains'
      },
      {
        field: 'creationTime',
        header: 'Thời gian thanh toán',
        width: 200, matchMode: 'equals',
        filterType: 'date-time-range',
        dataType: 'date-time'
      },
      {
        field: 'typePayment',
        header: 'Trạng thái thanh toán QRCode',
        width: 200,
        dataType: 'custom',
        filterType: 'dropdown',
        matchMode: 'contains',
        filterOptions: [
          { value: 0, label: 'Đang thanh toán' },
          { value: 1, label: 'Thanh toán lỗi' },
          { value: 2, label: 'Thanh toán thành công' },

        ],
        customCell(rowData: any): any {
          const type = {
            0: <span className='invoice-status invoice-status-5'>Đang thanh toán</span>,
            1: <span className='invoice-status invoice-status-1'>Thanh toán lỗi</span>,
            2: <span className='invoice-status invoice-status-0'>Thanh toán thành công</span>,
          };
          return type[rowData.typePayment]
        }
      },
      {
        field: 'messageLog',
        header: 'Mô tả lỗi',
        matchMode: 'contains'
      },
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      console.log("🚀 ~ ThanhToanQr ~ params:", params)

      return PaymentLogService.getList({
        ...params,
        ...(params.creationTime
          ? {
            fromDate: moment(params.creationTime.split(" - ")[0], "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DDTHH:mm:ss"),
            toDate: moment(params.creationTime.split(" - ")[1], "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DDTHH:mm:ss"),
          }
          : {})
      });
    }
  });

  return (
    <Fragment>
      {renderDataTable()}
    </Fragment>
  )
}

export default ThanhToanQr